import type { ReactNode } from 'react'
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import CheckQuizIcon from 'shared/icons/check-quiz-icon'
import { CourseStepButton } from '../components/course-state-button'
import { SecondaryButtonWithCustomTheme } from '../components/secondary-button-with-custom-theme'
import { useCourseQuiz } from '../hooks/use-course-quiz'
import useStepRouter from '../hooks/use-step-router'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'
import { CourseQuizResetButton } from './course-quiz-reset-button'
import { CourseQuizScreenWrapper } from './course-quiz-screen-wrapper'
import { CourseQuizStateContext } from './course-quiz-state/context'
import { CourseStatusEnum } from './course-quiz-state/types'

export const CourseQuizPassScreen = (): ReactNode => {
  const { t } = useTranslation()

  const { step } = useStepRouter()
  const { quizState, setQuizState } = useContext(CourseQuizStateContext)
  const { mutate, isValidating } = useCourseQuiz({ courseQuizId: step?.id })

  return (
    <CourseQuizScreenWrapper
      className={addPublicCustomClassNamePrefix(`course__quiz-results-screen--passed`)}
    >
      <CheckQuizIcon width="43px" height="43px" />
      <span className="mt-6 text-3xl font-bold text-THEME-primary lg:text-5xl">
        {t('course.quiz.pass.congratulation')}
      </span>
      <p className="mt-5 text-base font-semibold text-THEME-primary lg:text-xl">
        {t('course.quiz.pass.message', { percentage: quizState?.percentage })}
      </p>
      <div className="mt-7 flex w-full flex-wrap justify-center gap-3">
        <SecondaryButtonWithCustomTheme
          className={`shrink-0 font-bold ${addPublicCustomClassNamePrefix('course__button--see-quiz-results')}`}
          isLoading={isValidating}
          onClick={async () => {
            await mutate()
            setQuizState({ status: CourseStatusEnum.results })
          }}
        >
          {t('course.quiz.pass.see_results_button')}
        </SecondaryButtonWithCustomTheme>
        <CourseStepButton />
        <CourseQuizResetButton />
      </div>
    </CourseQuizScreenWrapper>
  )
}
